import { AxiosResponse } from "axios";
import { CaseEvent } from "./events";
import { axiosInstance } from "./common";

export enum PreSCNFicDecision {
  NO_FRAUD = "NO_FRAUD",
  ISSUE_SCN = "ISSUE_SCN",
  DEFERRED = "DEFERRED",
}

export interface PreSCNFicMeeting {
  meeting_id: string;
  convener: string;
  name_of_committee: string;
  members_of_committee: string[];
  decision?: PreSCNFicDecision;
  remarks?: string | null;
}

export interface PreSCNFicMeetingUI extends PreSCNFicMeeting {
  date_of_committee_meeting?: string;
  isDirty?: boolean;
  isAdded?: boolean;
}

export interface AddPreSCNFicMeetingRequest{
  convener: string;
  name_of_committee: string;
  members_of_committee: string[];
  decision?: PreSCNFicDecision;
  remarks?: string | null;
  date_of_committee: string; 
}

export interface UpdatePreSCNFicMeetingRequest {
  meeting_id: string;
  name_of_committee?: string;
  members_of_committee?: string[];
  remarks?: string | null;
}

export interface SavePreSCNFicMeetingRequest {
  add_requests?: AddPreSCNFicMeetingRequest[];
  update_requests?: UpdatePreSCNFicMeetingRequest[];
}


export interface SavePreSCNFicMeetingsResponse {
  meetings: PreSCNFicMeeting[];
  events?: CaseEvent[];
}

export interface GetPreSCNFICMeetingsResponse {
  meetings: PreSCNFicMeeting[];
}


const PreSCNFicAPI = {
  getMeetings: async (case_id: string) => {
    const response: AxiosResponse<GetPreSCNFICMeetingsResponse> =
      await axiosInstance.get(
        `/v1/cases/${case_id}/pre-scn-fic-meetings`
      );

    return response.data;
  },

  saveMeetings: async (
    case_id: string,
    payload: SavePreSCNFicMeetingRequest
  ) => {
    const response: AxiosResponse<SavePreSCNFicMeetingsResponse> =
      await axiosInstance.post(
        `/v1/cases/${case_id}/pre-scn-fic-meetings`,
        payload
      );

    return response.data;
  },
};

export default PreSCNFicAPI;


